import { createSlice } from '@reduxjs/toolkit';
import { isTokenExpired } from '../utils/jwtUtils';

// Validate token on initialization
const getValidToken = () => {
  const token = localStorage.getItem('token');
  if (token && !isTokenExpired(token)) {
    return token;
  }
  // Token is expired or invalid, remove it
  localStorage.removeItem('token');
  return null;
};

export const authSlice = createSlice({
  name: 'auth',
  initialState: {
    token: getValidToken(),
  },
  reducers: {
    login: (state, action) => {
      state.token = action.payload;
      localStorage.setItem('token', action.payload);
    },
    logout: (state) => {
      state.token = null;
      localStorage.removeItem('token');
    },
    checkTokenExpiration: (state) => {
      if (state.token && isTokenExpired(state.token)) {
        state.token = null;
        localStorage.removeItem('token');
      }
    },
  },
});

export const { login, logout, checkTokenExpiration } = authSlice.actions;

export default authSlice.reducer;
